import React from 'react'
import { Typography } from '@mui/material'
import { colors } from 'src/theme'
import tw from 'twin.macro'

export interface WarningContainerProps {
  title: string
  titleVariant?:
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6'
    | 'subtitle1'
    | 'subtitle2'
    | 'body1'
    | 'body2'
    | 'caption'
    | 'button'
    | 'overline'
  subtitle?: string
  className?: string
}

export const WarningContainer = ({
  title,
  subtitle,
  titleVariant = 'h5',
  className,
}: WarningContainerProps) => {
  return (
    <div css={tw`flex flex-row`} className={className}>
      <div css={tw`bg-[#FF6320] rounded-2xl w-1.5 mr-3`} />
      <div>
        <Typography variant={titleVariant}>{title}</Typography>
        {subtitle && (
          <Typography variant="body2" color={colors.SHADES_GREY_400} css={tw`mt-1`}>
            {subtitle}
          </Typography>
        )}
      </div>
    </div>
  )
}
